module.exports = __webpack_public_path__ + "img/高雄市.de0668c7.png";